export default "__VITE_ASSET__8972b75e__"